import { render } from "./HomeBodyComponent.vue?vue&type=template&id=386ac4ca&scoped=true"
import script from "./HomeBodyComponent.vue?vue&type=script&lang=js"
export * from "./HomeBodyComponent.vue?vue&type=script&lang=js"

import "./HomeBodyComponent.vue?vue&type=style&index=0&id=386ac4ca&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386ac4ca"]])

export default __exports__